import { useState } from "react";

import { AccountsTab } from "./helena/AccountsTab";
import { AnalysisTab } from "./helena/AnalysisTab";
import { CostsTab } from "./helena/CostsTab";

/** Aba Portal do Cliente (helena.revendai.com): contas (waba), análise IA das
 *  conversas e custos por cliente (core, /dev/portal-analysis). */

const SUBTABS = [
  { id: "contas", label: "Contas" },
  { id: "analise", label: "Análise IA" },
  { id: "custos", label: "Custos" },
] as const;

type SubTab = (typeof SUBTABS)[number]["id"];

export function HelenaTab() {
  const [tab, setTab] = useState<SubTab>("contas");

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
      <div role="tablist" aria-label="Portal do Cliente" style={{ display: "inline-flex", border: "1px solid var(--line-strong)", borderRadius: 8, overflow: "hidden", width: "fit-content" }}>
        {SUBTABS.map((t, i) => {
          const active = tab === t.id;
          return (
            <button
              key={t.id}
              role="tab"
              aria-selected={active}
              onClick={() => setTab(t.id)}
              style={{
                padding: "7px 16px", fontSize: 12.5, fontWeight: active ? 600 : 400,
                background: active ? "var(--brand-soft)" : "var(--surface-input)",
                color: active ? "var(--brand)" : "var(--ink-secondary)",
                border: "none", borderLeft: i > 0 ? "1px solid var(--line-strong)" : "none",
                cursor: "pointer", transition: "background 0.15s, color 0.15s",
              }}
            >
              {t.label}
            </button>
          );
        })}
      </div>

      {tab === "contas" && <AccountsTab />}
      {tab === "analise" && <AnalysisTab />}
      {tab === "custos" && <CostsTab />}
    </div>
  );
}
